<template>
  <modal title="Video" ref="modal">
    <iframe
      :src="media.url"
      width="100%"
      height="400"
      frameborder="0"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Media } from '@/type';
import Modal from '@/components/modal/Modal.vue';

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    Modal,
  },
  props: {
    media: {
      type: Object as () => Media,
      required: true,
    },
  },
});
</script>
